/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import api from 'api'
import { Button, Heading, HFlow, Icon, ModalCloseButton, Theme, useTheme, VFlow } from 'bold-ui'
import { reportFormatDate, useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { useEffect, useMemo, useRef } from 'react'

import { convertMChatToPerguntaRespostaInput } from '../converter-mchat'
import { MChatResultadoView } from '../mchat-resultado/MChatResultadoView'
import { MChatFieldModel } from '../model-mchat'

interface MChatModalTabResultadoProps {
  values: MChatFieldModel
  atendProfId: ID
  cidadaoId: ID
  isEditing: boolean
  onClickVoltar: () => void
}

export function MChatModalTabResultado(props: Readonly<MChatModalTabResultadoProps>) {
  const { values, atendProfId, cidadaoId, isEditing, onClickVoltar } = props

  const theme = useTheme()
  const styles = useMemo(() => createStyles(theme), [theme])
  const backButtonRef = useRef<HTMLButtonElement>()

  const { handleImpressaoPath } = useHandleImpressao()

  const handlePrint = (atendProfId: ID, cidadaoId: ID, mchat: MChatFieldModel) => {
    const input = {
      atendProfId: atendProfId,
      cidadaoId: cidadaoId,
      resultado: mchat.resultado,
      risco: mchat.risco,
      aplicacao: convertMChatToPerguntaRespostaInput(mchat),
    }

    handleImpressaoPath({
      apiPath: api.mchat.imprimirMChat,
      values: input,
      file: `MChat.pdf`,
      dateFormat: reportFormatDate,
    })
  }

  useEffect(() => {
    backButtonRef?.current.focus()
  }, [])

  return (
    <VFlow>
      <HFlow alignItems='flex-start' justifyContent='space-between'>
        <Button kind='normal' size='small' style={styles.voltarButton} onClick={onClickVoltar} innerRef={backButtonRef}>
          <Icon icon='arrowLeft' style={styles.icons} />
          {isEditing ? 'Voltar à edição' : 'Editar a avaliação'}
        </Button>
        <ModalCloseButton />
      </HFlow>
      <VFlow style={styles.modalSectionBody}>
        <HFlow alignItems='center' justifyContent='space-between'>
          <Heading level={1}>Resultado M-CHAT-R™</Heading>
          <Button
            kind='normal'
            size='small'
            style={styles.imprimirButton}
            onClick={(event) => {
              event.stopPropagation()
              handlePrint(atendProfId, cidadaoId, values)
            }}
          >
            <Icon icon='printerOutline' style={styles.icons} />
            Imprimir resultado
          </Button>
        </HFlow>
        <MChatResultadoView isInsideModal values={values} />
      </VFlow>
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  icons: css`
    margin-right: 0.5rem;
  `,
  voltarButton: css`
    margin-bottom: 1rem;
  `,
  imprimirButton: css`
    color: ${theme.pallete.primary.main};
    border-color: ${theme.pallete.primary.main};
  `,
  modalSectionBody: css`
    padding-right: 1rem;
  `,
})
